// extracted by mini-css-extract-plugin
export default {"textarea":"textarea_textarea__R6Mv5","label":"textarea_label__x5aWk"};